import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { AverageReportType, GroupType, HighlightedProps, SchoolReportType } from '../../types';
import { SectionLayout, getFilteredAverage, getOthersAverage } from '../modules';
import type { ChartIconType } from '../../../components/charts/types';
import { StudentProgress } from '../../../components';

type Props = {
  schoolReport: SchoolReportType
  showOthersData: boolean
  iconToUse: ChartIconType
} & HighlightedProps;

const MathsAgeDelta = ({ schoolReport, showOthersData, iconToUse, highlightedLabel, highlightedIds, onElementClick }: Props): JSX.Element => {
  const { translate } = useI18n();
  const avgMathsAgeDelta = (schoolReport.average.mathsAgeAverage ? (schoolReport.average.mathsAgeAverage - schoolReport.average.actualAgeAverage) : 0).toFixed(2);

  const dataToUse = (): (GroupType & AverageReportType)[] => {
    if (iconToUse === 'class') {
      return schoolReport.classes;
    } else return schoolReport.yearGroups;
  };

  const highlightedAverage = getFilteredAverage(dataToUse(), highlightedIds, (group) => group.chartsData?.mathsAgeDelta);
  const othersAverage = showOthersData ? getOthersAverage(dataToUse(), highlightedIds, (group) => group.chartsData?.mathsAgeDelta) : null;

  return (
    <SectionLayout
      title={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.title')}
      value={avgMathsAgeDelta}
      highlightLabel={highlightedLabel}
      highlightValue={highlightedAverage != null ? highlightedAverage.toFixed(2) : null}
      othersLabel={showOthersData && highlightedIds.length > 0 ? translate('pages.REPORTS.HEADERS.OTHERS') : null}
      othersValue={othersAverage != null ? othersAverage.toFixed(2) : null}
      unit={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.unit', { count: parseFloat(avgMathsAgeDelta) })}
      moreInfo={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.info')}
      id={'maths-age-delta-container'}
    >
      <div>
        <StudentProgress
          showOthersData={showOthersData}
          data={dataToUse()}
          chartType={'mathsAgeDelta'}
          type={iconToUse}
          highlightedIds={highlightedIds}
          thinAxis
          onElementClick={onElementClick}
        />
      </div>
    </SectionLayout>
  );
};

MathsAgeDelta.displayName = 'MathsAgeDelta';

export default MathsAgeDelta;
